import { render, staticRenderFns } from "./WorkView.vue?vue&type=template&id=61d44997&scoped=true&"
import script from "./WorkView.vue?vue&type=script&lang=js&"
export * from "./WorkView.vue?vue&type=script&lang=js&"
import style0 from "./WorkView.vue?vue&type=style&index=0&id=61d44997&prod&lang=scss&"
import style1 from "./WorkView.vue?vue&type=style&index=1&id=61d44997&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d44997",
  null
  
)

export default component.exports